module.exports = __webpack_public_path__ + "static/img-iphone-dashboard@2x.c08b6d5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-iphone-dashboard@2x.png
// module id = 791
// module chunks = 65120233804887